import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, API_ADMIN_ACTO_CONDICION_SUBESTANDAR, ROW_COUNT, API_ADMIN_TIPO_CAUSA_INMEDIATA } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { ITipoCausaInmediata } from "../../../entities/ITipoCausaInmediata";
import { IActoCondicionSubestandar } from "../../../entities/IActoCondicionSubestandar";

interface IActoCondicionSubestandarProps {
  cbTipoCausaInmediata?: Array<ITipoCausaInmediata>;
  items?: Array<any>;
}

const ActoCondicionSubestandar = ({ cbTipoCausaInmediata, items }: IActoCondicionSubestandarProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboTci, setComboTci] = useState<Array<ITipoCausaInmediata>>(cbTipoCausaInmediata || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = {
      PAGINA: 1,
      PAGINADO: pageSize,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
    };

    let paramsTitle = {
      PAGINA: 1,
      PAGINADO: pageSize,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
    };
    let result =
      items !== undefined
        ? { data: items ?? [] }
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_ACTO_CONDICION_SUBESTANDAR}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    params.PAGINADO = ROW_COUNT;
    let list = result.data;
    let pages = result.pages;
    setPages(pages);
    setListItems(list);
    const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_CAUSA_INMEDIATA}/getall`, { Authorization: `Bearer ${token}` }, paramsTitle)).result
      .data;
    setComboTci(combo);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: Partial<IActoCondicionSubestandar>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.TIPO_CAUSA = filter.ID_TIPO_CAUSA?.toString() || "";
    filter.ID_TIPO_CAUSA = undefined;
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_ACTO_CONDICION_SUBESTANDAR}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: IActoCondicionSubestandar, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";
    value.ID_TIPO_CAUSA = value.ID_TIPO_CAUSA || 1;
    if (value.ID == "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_ACTO_CONDICION_SUBESTANDAR}`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID != undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              ACTIVO: true,
              ID_ACTO: "1",
              ID_TIPO_CAUSA: 1,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TIPO_CAUSA: "",
              TITULO: "",
            },
            {}
          );
        }}></button>
      <AdminLista
        items={[
          {
            type: "ID_TIPO_CAUSA",
            value: comboTci //    se requiere para ordenar los items
              .map((tci) => {
                return { text: tci.TITULO, value: tci.ID };
              }),
          },
        ]}
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"ActoCondicionSubestandar"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Acto Condición Subestándar"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default ActoCondicionSubestandar;
